import Flickity from 'flickity';
import _ from 'lodash-es';

export default class PromoCarousel {
  constructor($el) {
    this.$el = $el;
    this.carousel = this.initCarousel();
    this.handleResize = _.debounce(this.handleResize.bind(this), 250);
    this.initCarousel = this.initCarousel.bind(this);

    $(window).on('resize', this.handleResize);
  }

  handleResize() {
    this.carousel.resize();
  }

  initCarousel() {
    return new Flickity(this.$el[0], {
      prevNextButtons: true,
      pageDots: false,
      draggable: true,
      wrapAround: false,
      autoPlay: false,
      adaptiveHeight: false,
      cellAlign: 'center',
      contain: true,
      groupCells: true,
    });
  }
}
